module.exports = __webpack_public_path__ + "img/reel2.11b5229f.png";